import { render, staticRenderFns } from "./product-group-list.vue?vue&type=template&id=17eddeb4&scoped=true&"
import script from "./product-group-list.vue?vue&type=script&lang=js&"
export * from "./product-group-list.vue?vue&type=script&lang=js&"
import style0 from "./product-group-list.vue?vue&type=style&index=0&id=17eddeb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eddeb4",
  null
  
)

export default component.exports